// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3Nabo","dragIcon":"SortableItem_dragIcon__1Cxl_","disabled":"SortableItem_disabled__t54Rh"};